export default __webpack_public_path__ + "static/pencilCrayons-cb4d42bf1b2c5851868dbc282ab01d87.jpg";